import { render, staticRenderFns } from "./tabPaginatedTable.vue?vue&type=template&id=a97c7c7a"
import script from "./tabPaginatedTable.vue?vue&type=script&lang=js"
export * from "./tabPaginatedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports